import React from 'react';
import { Card, Descriptions, Skeleton, Typography } from 'antd';
import { returnAgentUrl } from '../utils';

export const RMSAgents = ({ appliance, cloudAccountType }) => {
    return (
        <Card title="RMS Agents" size="small">
            <Descriptions column={1} size="small">
                <Descriptions.Item label="URL">{returnAgentUrl(appliance, cloudAccountType)}</Descriptions.Item>
            </Descriptions>
        </Card>
    );
};
